export default __webpack_public_path__ + "static/media/watch_better.0b22240b.png";